import { render, staticRenderFns } from "./SignUp.view.vue?vue&type=template&id=0cca5392&scoped=true&"
import script from "./SignUp.view.vue?vue&type=script&lang=js&"
export * from "./SignUp.view.vue?vue&type=script&lang=js&"
import style0 from "./SignUp.view.vue?vue&type=style&index=0&id=0cca5392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cca5392",
  null
  
)

export default component.exports